(function () {
  'use strict';

  function initFAQ() {
    var tabs   = Array.prototype.slice.call(document.querySelectorAll('.faq-tab'));
    var panels = Array.prototype.slice.call(document.querySelectorAll('.faq-panel'));
    var items  = Array.prototype.slice.call(document.querySelectorAll('.faq-item'));

    if (!tabs.length) return;

    /* ── Tab switching ── */
    function activateTab(cat) {
      tabs.forEach(function (t) {
        var active = t.dataset.cat === cat;
        t.classList.toggle('active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        p.classList.toggle('active', p.id === 'panel-' + cat);
      });
      /* collapse any open accordion when switching tabs */
      items.forEach(function (item) {
        if (item.classList.contains('open')) collapse(item);
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab.dataset.cat);
      });
    });

    /* ── Accordion ── */
    function expand(item) {
      var answer = item.querySelector('.faq-answer');
      var btn    = item.querySelector('.faq-question');
      answer.style.maxHeight = answer.scrollHeight + 'px';
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }

    function collapse(item) {
      var answer = item.querySelector('.faq-answer');
      var btn    = item.querySelector('.faq-question');
      answer.style.maxHeight = null;
      item.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.faq-question');
      btn.addEventListener('click', function () {
        var panel  = item.closest('.faq-panel');
        var isOpen = item.classList.contains('open');

        /* one-open-at-a-time per panel */
        Array.prototype.slice.call(panel.querySelectorAll('.faq-item.open')).forEach(function (openItem) {
          if (openItem !== item) collapse(openItem);
        });

        if (isOpen) { collapse(item); } else { expand(item); }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFAQ);
  } else {
    initFAQ();
  }
})();
